import React, { useEffect, useState } from "react";
import "common/css/master.css";
import "../../css/subjectAllocation.css";

const ClassReportTbl = (props) => {
    const { lstCls } = props;

    const [lstClass, setLstClass] = useState([]);
    const [lstClassFiltered, setLstClassFiltered] = useState([]);

    const [classFiltered, setClassFiltered] = useState("");
    const [sectionFiltered, setSectionFiltered] = useState("");
    const [subjectFiltered, setSubjectFiltered] = useState("");
    const [teacherFiltered, setTeacherFiltered] = useState("");

    useEffect(() => {
        // Initialize class data when props change
        setLstClass(lstCls);
        setLstClassFiltered(lstCls);
    }, [lstCls]);

    useEffect(() => {
        // Filter data whenever filters change
        filterClassReportTable();
    }, [classFiltered, sectionFiltered, subjectFiltered, teacherFiltered]);

    const filterClassReportTable = async () => {
        let filteredData = []; // Create a new array reference

        filteredData = lstClass.filter(item =>
            item.cls?.toLowerCase().includes(classFiltered.toLowerCase())
        );

        filteredData = filteredData.filter(item =>
            item.sec?.toLowerCase().includes(sectionFiltered.toLowerCase())
        );

        filteredData = filteredData.filter(item =>
            item.sub?.toLowerCase().includes(subjectFiltered.toLowerCase())
        );

        filteredData = filteredData.filter(item =>
            item.tch?.toLowerCase().includes(teacherFiltered.toLowerCase())
        );

        // console.log("filteredData length", filteredData.length);

        await setLstClassFiltered(filteredData); // Update state with a new array reference
        // console.log("filteredData after update", filteredData);
        // console.log("lstClassFiltered after update", lstClassFiltered);
    };

    return (
        <div>
            <div className="col-md-12 col-xs-12 col-centered padding-remove">
                <table className="tableLayout1">
                    <colgroup>
                        <col width="60" />
                        <col width="100" />
                        <col width="150" />
                        <col width="100" />
                        <col width="150" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <input
                                    type="text"
                                    className="form-control inp-search"
                                    value={classFiltered}
                                    onChange={(e) => setClassFiltered(e.target.value)}
                                    placeholder="Class"
                                />
                            </th>
                            <th>
                                <input
                                    type="text"
                                    className="form-control inp-search"
                                    value={sectionFiltered}
                                    onChange={(e) => setSectionFiltered(e.target.value)}
                                    placeholder="Section"
                                />
                            </th>
                            <th>
                                <input
                                    type="text"
                                    className="form-control inp-search"
                                    value={subjectFiltered}
                                    onChange={(e) => setSubjectFiltered(e.target.value)}
                                    placeholder="Subject"
                                />
                            </th>
                            <th>Weekly Periods</th>
                            <th>
                                <input
                                    type="text"
                                    className="form-control inp-search"
                                    value={teacherFiltered}
                                    onChange={(e) => setTeacherFiltered(e.target.value)}
                                    placeholder="Teacher"
                                />
                            </th>
                        </tr>
                    </thead>
                </table>
                <div
                    className="tableDiv"
                    style={{
                        height: "60vh",
                        pointerEvents: "auto",
                        zIndex: 1,
                        position: "relative",
                    }}
                >
                    <table className="tableLayout" style={{ position: "relative" }}>
                        <colgroup>
                            <col width="60" />
                            <col width="100" />
                            <col width="150" />
                            <col width="100" />
                            <col width="150" />
                        </colgroup>
                        <tbody id="classReportTable">
                            {lstClassFiltered && lstClassFiltered.length ?
                                lstClassFiltered.map((item, idx) => (
                                    <tr
                                        key={
                                            "idx" +
                                            idx +
                                            (item.clsId ?? "cls") +
                                            (item.secId ?? "sec") +
                                            (item.subId ?? "nosub") +
                                            (item.tchId ?? "notch")
                                        }
                                    >
                                        <td className="text-left">{item.cls}</td>
                                        <td className="text-center">{item.sec}</td>
                                        <td className="text-left">{item.sub}</td>
                                        <td className="text-center">{item.totalPeriod}</td>
                                        <td className="text-left">{item.tch}</td>
                                    </tr>
                                ))
                                : null
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ClassReportTbl;
